import Vue from 'vue';
import { $get } from '@/utils/axios-request';
import { Message } from 'element-ui';

import { base64 } from './base64';
// Base64,hmac,sha1,crypto相关算法
import './hmac';
import './sha1';
import { Crypto } from './crypto';

const getOssSignApi = (params:any) => $get('/api/v1/auth/ALIYUN/zncgfjwfjqwfjwqlfebopo/zncgfjwfjqwfjwqlfebopo', params);

export class OssUpload extends Vue {
  public ossLoading:any = false;

  public filePathMixins:any = '';

  public oss:any = {};

  public uploadUrlMixins:any = '';

  public ossUploadNameMixins:any = 'file';

  public ossUploadFormDataMixins:any = {};

  public fileList:any = [];

  public async ossUploadBeforeMixins(file:any) {
    await this.uploadFile(file, 'common/images/', () => {
      Message({
        type: 'success',
        message: '上传成功',
      });
    }, () => {
      Message({
        type: 'error',
        message: '上传失败',
      });
    }).then((res:any) => true).catch((e:any) => false);
    console.log(this.uploadUrlMixins);
    console.log(this.ossUploadFormDataMixins);
    console.log(this.ossUploadNameMixins);
    return true;
  }

  async uploadImg(dir:any, ossInfo:any, successc:any, failc:any, filePath:any) {
  // 图片名字 可以自行定义，     这里是采用当前的时间戳 + 150内的随机数来给图片命名的
    const aliyunFileKey = `${dir + new Date().getTime() + Math.floor(Math.random() * 150)}.png`;

    const aliyunServerURL = ossInfo.urlPrefix;// OSS地址，需要https
    const accessid = ossInfo.accessKeyId;
    const policyBase64 = this.getPolicyBase64();
    const signature = this.getSignature(policyBase64, ossInfo.accessKeySecret);// 获取签名
    console.log(ossInfo.urlPrefix);
    this.uploadUrlMixins = aliyunServerURL;
    this.filePathMixins = filePath;
    this.ossUploadFormDataMixins = {
      key: aliyunFileKey,
      policy: policyBase64,
      OSSAccessKeyId: accessid,
      success_action_status: '200',
      'x-oss-security-token': ossInfo.securityToken,
      signature,
    };

    console.log(this.ossUploadFormDataMixins);
  }

  /*
  *上传文件到阿里云oss
  *@param - filePath :图片的本地资源路径
  *@param - dir:表示要传到哪个目录下
  *@param - successc:成功回调
  *@param - failc:失败回调
  */
  uploadFile(filePath:any, dir:any, successc:any, failc:any):any {
    if (!filePath || filePath.length < 9) {
      Message({
        type: 'error',
        message: '图片错误,请重试',
      });
      return false;
    }
    console.log('上传图片.....');
    return new Promise((resolve, reject) => {
      getOssSignApi({}).then(async (res:any) => {
        console.log('oss');
        console.log(res.data.data);
        await this.uploadImg(dir, res.data.data, successc, failc, filePath);
        resolve();
      }).catch((e:any) => {
        console.log(e);
        reject();
      });
    });
  }

  // policy base64 码
  getPolicyBase64() {
    const date = new Date();
    date.setHours(date.getHours() + 80000);
    const srcT = date.toISOString();
    const policyText = {
      expiration: srcT, // 设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
      conditions: [
        ['content-length-range', 0, 5 * 1024 * 1024], // 设置上传文件的大小限制,5mb
      ],
    };

    const policyBase64 = base64.encode(JSON.stringify(policyText));
    return policyBase64;
  }

  getSignature(policyBase64:any, accessKeySecret:any) {
    const accesskey = accessKeySecret;
    console.log('accesskey============');
    console.log(accesskey);
    const bytes = Crypto.HMAC(Crypto.SHA1, policyBase64, accesskey, {
      asBytes: true,
    });
    const signature = Crypto.util.bytesToBase64(bytes);
    return signature;
  }
}
